// components/StationCard.tsx
import React, { memo } from "react";
import "./StationCard.css";
import { getStationDisplayProps } from "../../../../utils/getStationState";

interface StationProps {
  station: {
    id: number;
    place: string;
    state_id: number;
    status_id: number;
    currentA: number | null;
    energyWh: number | null;
    gps: string;
    last_session?: { stop_reason?: number | null } | null;
  };
  onSelect: () => void;
  role?: string;
}

const StationCard: React.FC<StationProps> = ({ station, onSelect, role }) => {
  const { place, currentA, energyWh } = station;

  const { state, colorClass, icon, color, inactive, hint } =
    getStationDisplayProps(station);
  const isOffline = state === "offline";
  const unavailable = state === "недоступно" || state === "нет связи";

  // Преобразуем состояние в CSS-класс
  const stateClass = `state-${
    state
      .toLowerCase() // Приводим к нижнему регистру
      .replace(/[()]/g, "") // Удаляем скобки
      .replace(/\s+/g, "-") // Заменяем пробелы на дефисы
  }`;

  return (
    <div
      role="button"
      tabIndex={0}
      className={`station-card ${stateClass}`}
      onClick={onSelect}
    >
      {/* === ШАПКА === (всегда белая) */}
      <div className="station-header">
        <h3 className="station-title">Место: {place}</h3>
        <div>/</div>
        {/* `С2`: подсказка «под статусом» — всплывает при наведении. В карточке
            фиксированной высоты места на постоянную строку нет; та же подсказка
            показана текстом в окне станции. */}
        <div
          className={`station-status ${colorClass}`}
          style={{ color }}
          title={hint ?? undefined}
          data-hint={hint ?? undefined}
        >
          <span>{state}</span>
          <div className="station-icon">{icon}</div>
        </div>
      </div>

      <div className="spaceLine" />

      {/* === ТЕЛО === (заливается цветом по состоянию) */}
      <div className="station-body">
        <div className="station-data">
          <span>Текущее потребление:</span>
          <strong
            className="station_value"
            style={{
              color: inactive ? "var(--grey4)" : "var(--green)",
            }}
          >
            {currentA !== null ? `${currentA} A` : "-"}
          </strong>
        </div>
        <div className="station-data">
          <span>Показания счётчика:</span>
          <strong
            className="station_value"
            style={{
              color: inactive ? "var(--grey4)" : "var(--green)",
            }}
          >
            {energyWh !== null ? `${energyWh / 1000} кВт·ч` : "-"}
          </strong>
        </div>
      </div>
    </div>
  );
};

export default memo(StationCard, (prevProps, nextProps) => {
  const prev = prevProps.station;
  const next = nextProps.station;
  return (
    prev.id === next.id &&
    prev.status_id === next.status_id &&
    prev.state_id === next.state_id &&
    prev.currentA === next.currentA &&
    prev.energyWh === next.energyWh &&
    prev.place === next.place &&
    prev.gps === next.gps
  );
});
